if (!window.Eurus.loadedScript.has('combo-variant-select.js')) {
  window.Eurus.loadedScript.add('combo-variant-select.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xComboPrice', {
        items: {},
        moneyFormats: {},
        observedSections: new Set(),
        register(sectionId, productId, variant, moneyFormat) {
          this.items[`${sectionId}:${productId}`] = variant;
          if (moneyFormat) this.moneyFormats[sectionId] = moneyFormat;
          this.observeBadges(sectionId);
          this.render(sectionId);
        },
        observeBadges(sectionId) {
          if (this.observedSections.has(sectionId)) return;
          this.observedSections.add(sectionId);
          document.querySelectorAll(`#price-${sectionId} .x-badges-container, #price-sticky-${sectionId} .x-badges-container`).forEach((badgesContainer) => {
            const observer = new MutationObserver(() => this.render(sectionId));
            observer.observe(badgesContainer, { childList: true, subtree: true });
          });
        },
        totals(sectionId) {
          const prefix = `${sectionId}:`;
          let price = 0;
          let compareAtPrice = 0;
          Object.keys(this.items).forEach((key) => {
            if (!key.startsWith(prefix)) return;
            const variant = this.items[key];
            if (!variant) return;
            price += variant.price || 0;
            compareAtPrice += variant.compare_at_price || variant.price || 0;
          });
          return { price, compareAtPrice };
        },
        isSoldOut(sectionId) {
          const prefix = `${sectionId}:`;
          return Object.keys(this.items).some((key) => {
            if (!key.startsWith(prefix)) return false;
            const variant = this.items[key];
            return Boolean(variant) && variant.available === false;
          });
        },
        patchAddToCart(sectionId) {
          const soldOut = this.isSoldOut(sectionId);
          document.querySelectorAll(`#x-atc-button-${sectionId}, #x-atc-button-sticky-${sectionId}`).forEach((button) => {
            button.disabled = soldOut;
            button.classList.toggle('disabled', soldOut);
            const textEl = button.querySelector('.x-atc-text');
            if (!textEl) return;
            if (soldOut && button.dataset.soldOutText) {
              textEl.textContent = button.dataset.soldOutText;
            } else if (!soldOut && button.dataset.addText) {
              textEl.textContent = button.dataset.addText;
            }
          });
        },
        syncFromSticky(event, sectionId) {
          const select = event.target;
          const productId = select.dataset.comboProductId;
          const optionIndex = select.dataset.optionIndex;
          const radio = document.querySelector(
            `input[name="combo-${sectionId}-${productId}-${optionIndex}"][value="${CSS.escape(select.value)}"]`
          );
          if (!radio) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        },
        patchStickySelects(sectionId) {
          document.querySelectorAll(`#variant-update-sticky-${sectionId} select[data-combo-product-id]`).forEach((select) => {
            const productId = select.dataset.comboProductId;
            const optionIndex = select.dataset.optionIndex;
            const checkedRadio = document.querySelector(`input[name="combo-${sectionId}-${productId}-${optionIndex}"]:checked`);
            const newValue = checkedRadio ? checkedRadio.value : '';
            if (select.value !== newValue) select.value = newValue;
          });
        },
        patchBadge(container, price, compareAtPrice) {
          let saleText = '';
          if (compareAtPrice > price && compareAtPrice > 0) {
            let sale = Math.round((compareAtPrice - price) * 100 / compareAtPrice);
            sale = sale === 100 ? 99 : sale;
            saleText = sale > 0 ? `${sale}%` : '';
          }
          container.querySelectorAll('.x-badges-container .x-badge-text .leading-normal').forEach((span) => {
            if (!/\d+%/.test(span.textContent)) return;
            const badgeContainer = span.closest('.x-badge-container');
            if (!saleText) {
              if (badgeContainer && badgeContainer.style.display !== 'none') badgeContainer.style.display = 'none';
              return;
            }
            if (badgeContainer && badgeContainer.style.display === 'none') badgeContainer.style.display = '';
            const newText = span.textContent.replace(/\d+%/, saleText);
            if (newText !== span.textContent) span.textContent = newText;
          });
        },
        render(sectionId) {
          const { price, compareAtPrice } = this.totals(sectionId);
          const moneyFormat = this.moneyFormats[sectionId];
          if (!moneyFormat) return;
          const formatMoney = (cents) => Alpine.store('xHelper').formatMoney(cents, moneyFormat);

          document.querySelectorAll(`#price-${sectionId}, #price-sticky-${sectionId}`).forEach((container) => {
            const priceTarget = container.querySelector('.target-price');
            if (priceTarget) priceTarget.textContent = price;

            const compareTarget = container.querySelector('.target-compare-at-price');
            if (compareTarget) compareTarget.textContent = compareAtPrice;

            const priceEl = container.querySelector('.price-sale') || container.querySelector('.price span');
            if (priceEl) priceEl.textContent = formatMoney(price);

            const compareEl = container.querySelector('.price-compare');
            if (compareEl) compareEl.textContent = formatMoney(compareAtPrice);

            const compareWrapper = compareEl ? compareEl.closest('small') : null;
            if (compareWrapper) compareWrapper.classList.toggle('hidden', compareAtPrice <= price);

            this.patchBadge(container, price, compareAtPrice);
          });

          this.patchAddToCart(sectionId);
          this.patchStickySelects(sectionId);
        }
      });

      Alpine.data('xComboVariantSelect', (el, sectionId, productId, moneyFormat, available) => ({
        variants: [],
        currentVariant: null,
        selectedOptions: [],
        included: available !== false,
        init() {
          this.variants = JSON.parse(el.querySelector('script[data-combo-variants]').textContent);
          this.currentVariant = null;
          this.selectedOptions = [];
          // Nothing is selected yet, so this group contributes nothing to the running total
          // until the shopper actually picks a size for it.
          Alpine.store('xComboPrice').register(sectionId, productId, null, moneyFormat);
        },
        updateVariant() {
          this.currentVariant = this.variants.find((variant) =>
            variant.options.every((option, index) => option === this.selectedOptions[index])
          ) || null;
          Alpine.store('xComboPrice').register(sectionId, productId, this.included ? this.currentVariant : null, moneyFormat);
        },
        isValueAvailable(optionIndex, value) {
          return this.variants.some((variant) =>
            variant.available &&
            variant.options[optionIndex] === value &&
            variant.options.every((option, index) =>
              index === optionIndex || this.selectedOptions[index] == null || option === this.selectedOptions[index]
            )
          );
        }
      }));
    });
  });
}
